import { TooltipProvider } from '@au/ui';
import { AppAuLabelsProvider, UserLanguageSelect, UserLocaleProvider } from '@fsd/app/locale';
import { ThemeToggle, useDocumentTheme } from '@fsd/app/theme';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { AmaruWordmark } from './amaru-wordmark';
import styles from './app-layout.module.css';

// `au-scope`, el rol `body` y el `TooltipProvider` de `@au/ui`: una vez, para todo src/fsd/.
// `ScrollRestoration`: una navegación nueva arranca arriba y el botón atrás recupera el scroll.
// Barras provisorias, como `<div>`: ver frontend-fsd.md § Marco provisorio.
export function AppLayout() {
  // Acá y no en FsdContext: al salir de la rama fsd se desmonta y quita `au-light` del root.
  const { theme, toggle } = useDocumentTheme();

  // La preferencia de idioma necesita sesión: va acá, bajo AuthGuard, y no en FsdContext.
  return (
    <UserLocaleProvider>
      <AppAuLabelsProvider>
        <div className={`au-scope ${styles.appLayout}`}>
          <div className={styles.topBar}>
            <AmaruWordmark height={18} />
            {/* Controles globales de la barra, a la derecha del wordmark: tema e idioma. */}
            <div className={styles.topBarActions}>
              <ThemeToggle theme={theme} onToggle={toggle} />
              <UserLanguageSelect />
            </div>
          </div>
          <div className={styles.body}>
            <div className={styles.sideBar} />
            <div className={styles.content}>
              <TooltipProvider>
                <Outlet />
              </TooltipProvider>
            </div>
          </div>
          <ScrollRestoration />
        </div>
      </AppAuLabelsProvider>
    </UserLocaleProvider>
  );
}
